import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d636e114&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d636e114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d636e114')) {
      api.createRecord('d636e114', component.options)
    } else {
      api.reload('d636e114', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d636e114&scoped=true", function () {
      api.rerender('d636e114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Solution/index.vue"
export default component.exports